import { render, staticRenderFns } from "./Picks.vue?vue&type=template&id=fff63738&scoped=true&lang=pug&"
import script from "./Picks.vue?vue&type=script&lang=js&"
export * from "./Picks.vue?vue&type=script&lang=js&"
import style0 from "./Picks.vue?vue&type=style&index=0&id=fff63738&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff63738",
  null
  
)

export default component.exports